"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emergencyRepay = emergencyRepay;
exports.emergencyRepayWithUpatePool = emergencyRepayWithUpatePool;
const index_js_1 = require("../index.js");
const transactions_1 = require("@mysten/sui/transactions");
const index_js_2 = require("../pyth/index.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const alphalend_sdk_1 = require("@alphafi/alphalend-sdk");
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
const decimal_js_1 = require("decimal.js");
const lending_1 = require("@naviprotocol/lending");
const naviPolyfill_js_1 = require("./naviPolyfill.js");
const alphalendClient = new alphalend_sdk_1.AlphalendClient("mainnet", (0, alphafi_sdk_1.getSuiClient)());
// await alphalendClient.updatePrices(txb, [coinsList["STSUI"].type, "0x2::sui::SUI"]);
const emergencyCap = (0, alphafi_sdk_1.getConf)().ALPHAFI_EMERGENCY_CAP;
async function emergencyRepay(poolName, percentagetToReduceTheBorrowPercentage) {
    const client = (0, alphafi_sdk_1.getSuiClient)();
    if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
        const supplyCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin;
        const borrowCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin;
        const allMarkets = await alphalendClient.getAllMarkets();
        const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, false));
        if (!investor) {
            throw new Error(`could not fetch investor for ${poolName}`);
        }
        let ltv = 0;
        if (allMarkets) {
            for (const market of allMarkets) {
                if (market.coinType === alphafi_sdk_1.coinsList[supplyCoin].type) {
                    ltv = market.ltv.toNumber();
                    break;
                }
            }
        }
        else {
            throw new Error("could not fetch markets");
        }
        const position_id = poolName === "ALPHALEND-LOOP-SUI-STSUI"
            ? "0xe8138350422974a56da1eac6c9fbeecac4d4ceec1a505bd4f769056358ae5d9c"
            : investor.content.fields.position_cap.fields.position_id;
        const userPortfolio = await alphalendClient.getUserPortfolioFromPosition(position_id);
        if (userPortfolio) {
            let supply = userPortfolio.suppliedAmounts.get(Number(alphafi_sdk_1.alphalendMarketIdMap[supplyCoin]));
            const debt = userPortfolio.borrowedAmounts.get(Number(alphafi_sdk_1.alphalendMarketIdMap[borrowCoin]));
            if (supply && debt) {
                if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
                    supply = supply.mul(await (0, stsui_sdk_1.stSuiExchangeRate)((0, alphafi_sdk_1.getConf)().LST_INFO, false));
                }
                const currentDebtToSupplyRatio = debt.div(supply);
                const safeDebtToSupplyRatio = new decimal_js_1.Decimal(ltv).mul(new decimal_js_1.Decimal(investor.content.fields.safe_borrow_percentage).div(1000000));
                console.log(supply.toString(), debt.toString(), currentDebtToSupplyRatio.toString(), safeDebtToSupplyRatio.toString(), currentDebtToSupplyRatio.gte(safeDebtToSupplyRatio), "oooejeojeojeoj");
                if (currentDebtToSupplyRatio.gte(safeDebtToSupplyRatio)) {
                    const txb = new transactions_1.Transaction();
                    const pool = alphafi_sdk_1.poolInfo[poolName];
                    const C = (0, alphafi_sdk_1.getConf)();
                    const typeList = [
                        supplyCoin === "SUI" ? "0x2::sui::SUI" : alphafi_sdk_1.coinsList[supplyCoin].type,
                    ];
                    if (borrowCoin !== supplyCoin) {
                        typeList.push(borrowCoin === "SUI"
                            ? "0x2::sui::SUI"
                            : alphafi_sdk_1.coinsList[borrowCoin].type);
                    }
                    await alphalendClient.updatePrices(txb, typeList);
                    if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
                        txb.moveCall({
                            target: `${pool.packageId}::alphafi_navi_sui_stsui_investor::emergency_repay`,
                            arguments: [
                                txb.object(emergencyCap),
                                txb.object(C.ALPHA_5_VERSION),
                                txb.object(pool.investorId),
                                txb.pure.u256(percentagetToReduceTheBorrowPercentage),
                                txb.object(C.LENDING_PROTOCOL_ID),
                                txb.object(C.LST_INFO),
                                txb.object(C.SUI_SYSTEM_STATE),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (alphafi_sdk_1.poolInfo[poolName].strategyType === "SINGLE-LOOPING") {
                        txb.moveCall({
                            target: `${pool.packageId}::alphafi_alphalend_single_loop_investor::emergency_repay`,
                            typeArguments: [alphafi_sdk_1.coinsList[supplyCoin].type],
                            arguments: [
                                txb.object(emergencyCap),
                                txb.object(C.ALPHA_ALPHALEND_VERSION),
                                txb.object(pool.investorId),
                                txb.pure.u256(percentagetToReduceTheBorrowPercentage),
                                txb.object(C.LENDING_PROTOCOL_ID),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    return txb;
                }
            }
            else {
                throw new Error("could not fetch supply or debt");
            }
        }
        else {
            throw new Error("could not fetch userPortfolio");
        }
    }
    else {
        const loopingAccountAddress = alphafi_sdk_1.loopingAccountAddresses[poolName];
        const supplyCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin;
        const borrowCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin;
        const supplyCoinType = alphafi_sdk_1.coinsList[supplyCoin].type;
        const borrowCoinType = alphafi_sdk_1.coinsList[borrowCoin].type;
        // const portfolio = await getAddressPortfolio(
        //   loopingAccountAddress,
        //   false,
        //   client,
        // );
        const [portfolio, supplyPoolInfo] = await (0, naviPolyfill_js_1.withNaviFetch)(async () => {
            return Promise.all([
                (0, lending_1.getLendingState)(loopingAccountAddress),
                (0, lending_1.getPool)(supplyCoinType),
            ]);
        });
        const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, false));
        const safeDebtToSupplyRatio = (Number(supplyPoolInfo.ltv) *
            Number(investor.content.fields.safe_borrow_percentage)) /
            10000;
        const currentDebt = Number(portfolio.find((p) => p.pool.coinType === borrowCoinType)?.borrowBalance);
        const [borrowCoinPrice, supplyCoinPrice] = await (0, index_js_2.getLatestPrices)([
            (borrowCoin + "/USD"),
            (supplyCoin + "/USD"),
        ], false);
        const currentSupply = Number(portfolio.find((p) => p.pool.coinType === supplyCoinType)?.supplyBalance);
        if (borrowCoinPrice && supplyCoinPrice && currentDebt && currentSupply) {
            const currentDebtPrice = currentDebt * Number(borrowCoinPrice);
            const currentDebtInSupplyCoin = currentDebtPrice / Number(supplyCoinPrice);
            const currentDebtToSupplyRatio = currentDebtInSupplyCoin / currentSupply;
            if (currentDebtToSupplyRatio >= safeDebtToSupplyRatio) {
                const C = (0, alphafi_sdk_1.getConf)();
                const poolData = alphafi_sdk_1.poolInfo[poolName];
                if (poolName === "NAVI-LOOP-USDC-USDT") {
                    const txb = new transactions_1.Transaction();
                    txb.moveCall({
                        target: `${(0, alphafi_sdk_1.getConf)().ALPHA_2_LATEST_PACKAGE_ID}::alphafi_navi_native_usdc_usdt_investor::emergency_repay`,
                        arguments: [
                            txb.object(emergencyCap), // adminCap
                            txb.object(C.ALPHA_2_VERSION),
                            txb.object(poolData.investorId),
                            txb.object(C.CLOCK_PACKAGE_ID),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(C.NAVI_USDC_POOL),
                            txb.object(C.NAVI_USDT_POOL),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.pure.u256(percentagetToReduceTheBorrowPercentage),
                        ],
                    });
                    return txb;
                }
                else if (poolName === "NAVI-LOOP-USDT-USDC") {
                    const txb = new transactions_1.Transaction();
                    txb.moveCall({
                        target: `${(0, alphafi_sdk_1.getConf)().ALPHA_5_LATEST_PACKAGE_ID}::alphafi_navi_usdt_usdc_investor::emergency_repay`,
                        arguments: [
                            txb.object(emergencyCap), // adminCap
                            txb.object(C.ALPHA_5_VERSION),
                            txb.object(poolData.investorId),
                            txb.object(C.CLOCK_PACKAGE_ID),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(C.NAVI_USDT_POOL),
                            txb.object(C.NAVI_USDC_POOL),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.pure.u256(percentagetToReduceTheBorrowPercentage),
                        ],
                    });
                    return txb;
                }
            }
        }
        else {
            throw new Error(`borrowCoinPrice: ${borrowCoinPrice}, supplyCoinPrice: ${supplyCoinPrice}, currentDebt: ${currentDebt}, currentSupply: ${currentSupply}`);
        }
    }
}
async function emergencyRepayWithUpatePool(poolName, percentagetToReduceTheBorrowPercentage) {
    const client = (0, alphafi_sdk_1.getSuiClient)();
    if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
        const supplyCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin;
        const borrowCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin;
        const allMarkets = await alphalendClient.getAllMarkets();
        const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, false));
        if (!investor) {
            throw new Error(`could not fetch investor for ${poolName}`);
        }
        let ltv = 0;
        if (allMarkets) {
            for (const market of allMarkets) {
                if (market.coinType === alphafi_sdk_1.coinsList[supplyCoin].type) {
                    ltv = market.ltv.toNumber();
                    break;
                }
            }
        }
        else {
            throw new Error("could not fetch markets");
        }
        const position_id = poolName === "ALPHALEND-LOOP-SUI-STSUI"
            ? "0xe8138350422974a56da1eac6c9fbeecac4d4ceec1a505bd4f769056358ae5d9c"
            : investor.content.fields.position_cap.fields.position_id;
        const userPortfolio = await alphalendClient.getUserPortfolioFromPosition(position_id);
        if (userPortfolio) {
            let supply = userPortfolio.suppliedAmounts.get(Number(alphafi_sdk_1.alphalendMarketIdMap[supplyCoin]));
            const debt = userPortfolio.borrowedAmounts.get(Number(alphafi_sdk_1.alphalendMarketIdMap[borrowCoin]));
            if (supply && debt) {
                if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
                    supply = supply.mul(await (0, stsui_sdk_1.stSuiExchangeRate)((0, alphafi_sdk_1.getConf)().LST_INFO, false));
                }
                const currentDebtToSupplyRatio = debt.div(supply);
                const safeDebtToSupplyRatio = new decimal_js_1.Decimal(ltv).mul(new decimal_js_1.Decimal(investor.content.fields.safe_borrow_percentage).div(1000000));
                console.log(supply.toString(), debt.toString(), currentDebtToSupplyRatio.toString(), safeDebtToSupplyRatio.toString(), currentDebtToSupplyRatio.gte(safeDebtToSupplyRatio), "oooejeojeojeoj");
                if (currentDebtToSupplyRatio.gte(safeDebtToSupplyRatio)) {
                    let txb = await (0, index_js_1.getAutoCompoundSingleTxb)(poolName);
                    if (!txb) {
                        txb = new transactions_1.Transaction();
                    }
                    const pool = alphafi_sdk_1.poolInfo[poolName];
                    const C = (0, alphafi_sdk_1.getConf)();
                    const typeList = [
                        supplyCoin === "SUI" ? "0x2::sui::SUI" : alphafi_sdk_1.coinsList[supplyCoin].type,
                    ];
                    if (borrowCoin !== supplyCoin) {
                        typeList.push(borrowCoin === "SUI"
                            ? "0x2::sui::SUI"
                            : alphafi_sdk_1.coinsList[borrowCoin].type);
                    }
                    await alphalendClient.updatePrices(txb, typeList);
                    if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
                        txb.moveCall({
                            target: `${pool.packageId}::alphafi_navi_sui_stsui_investor::emergency_repay`,
                            arguments: [
                                txb.object(emergencyCap),
                                txb.object(C.ALPHA_5_VERSION),
                                txb.object(pool.investorId),
                                txb.pure.u256(percentagetToReduceTheBorrowPercentage),
                                txb.object(C.LENDING_PROTOCOL_ID),
                                txb.object(C.LST_INFO),
                                txb.object(C.SUI_SYSTEM_STATE),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (alphafi_sdk_1.poolInfo[poolName].strategyType === "SINGLE-LOOPING") {
                        txb.moveCall({
                            target: `${pool.packageId}::alphafi_alphalend_single_loop_investor::emergency_repay`,
                            typeArguments: [alphafi_sdk_1.coinsList[supplyCoin].type],
                            arguments: [
                                txb.object(emergencyCap),
                                txb.object(C.ALPHA_ALPHALEND_VERSION),
                                txb.object(pool.investorId),
                                txb.pure.u256(percentagetToReduceTheBorrowPercentage),
                                txb.object(C.LENDING_PROTOCOL_ID),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    return txb;
                }
            }
            else {
                throw new Error("could not fetch supply or debt");
            }
        }
        else {
            throw new Error("could not fetch userPortfolio");
        }
    }
    else {
        const loopingAccountAddress = alphafi_sdk_1.loopingAccountAddresses[poolName];
        const supplyCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin;
        const borrowCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin;
        const supplyCoinType = alphafi_sdk_1.coinsList[supplyCoin].type;
        const borrowCoinType = alphafi_sdk_1.coinsList[borrowCoin].type;
        const [portfolio, supplyPoolInfo] = await (0, naviPolyfill_js_1.withNaviFetch)(async () => {
            return Promise.all([
                (0, lending_1.getLendingState)(loopingAccountAddress),
                (0, lending_1.getPool)(supplyCoinType),
            ]);
        });
        const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, false));
        const safeDebtToSupplyRatio = (Number(supplyPoolInfo.ltv) *
            Number(investor.content.fields.safe_borrow_percentage)) /
            10000;
        const currentDebt = Number(portfolio.find((p) => p.pool.coinType === borrowCoinType)?.borrowBalance);
        const [borrowCoinPrice, supplyCoinPrice] = await (0, index_js_2.getLatestPrices)([
            (borrowCoin + "/USD"),
            (supplyCoin + "/USD"),
        ], false);
        const currentSupply = Number(portfolio.find((p) => p.pool.coinType === supplyCoinType)?.supplyBalance);
        if (borrowCoinPrice && supplyCoinPrice && currentDebt && currentSupply) {
            const currentDebtPrice = currentDebt * Number(borrowCoinPrice);
            const currentDebtInSupplyCoin = currentDebtPrice / Number(supplyCoinPrice);
            const currentDebtToSupplyRatio = currentDebtInSupplyCoin / currentSupply;
            if (currentDebtToSupplyRatio >= safeDebtToSupplyRatio) {
                const C = (0, alphafi_sdk_1.getConf)();
                const poolData = alphafi_sdk_1.poolInfo[poolName];
                if (poolName === "NAVI-LOOP-USDC-USDT") {
                    let txb = await (0, index_js_1.getAutoCompoundSingleTxb)(poolName, undefined, await (0, index_js_1.groupedRewards)([poolName]));
                    if (!txb) {
                        txb = new transactions_1.Transaction();
                    }
                    txb.moveCall({
                        target: `${(0, alphafi_sdk_1.getConf)().ALPHA_2_LATEST_PACKAGE_ID}::alphafi_navi_native_usdc_usdt_investor::emergency_repay`,
                        arguments: [
                            txb.object(emergencyCap), // adminCap
                            txb.object(C.ALPHA_2_VERSION),
                            txb.object(poolData.investorId),
                            txb.object(C.CLOCK_PACKAGE_ID),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(C.NAVI_USDC_POOL),
                            txb.object(C.NAVI_USDT_POOL),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.pure.u256(percentagetToReduceTheBorrowPercentage),
                        ],
                    });
                    return txb;
                }
                else if (poolName === "NAVI-LOOP-USDT-USDC") {
                    const txb = new transactions_1.Transaction();
                    txb.moveCall({
                        target: `${(0, alphafi_sdk_1.getConf)().ALPHA_5_LATEST_PACKAGE_ID}::alphafi_navi_usdt_usdc_investor::emergency_repay`,
                        arguments: [
                            txb.object(emergencyCap), // adminCap
                            txb.object(C.ALPHA_5_VERSION),
                            txb.object(poolData.investorId),
                            txb.object(C.CLOCK_PACKAGE_ID),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(C.NAVI_USDT_POOL),
                            txb.object(C.NAVI_USDC_POOL),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.pure.u256(percentagetToReduceTheBorrowPercentage),
                        ],
                    });
                    return txb;
                }
            }
        }
        else {
            throw new Error(`borrowCoinPrice: ${borrowCoinPrice}, supplyCoinPrice: ${supplyCoinPrice}, currentDebt: ${currentDebt}, currentSupply: ${currentSupply}`);
        }
    }
}
//# sourceMappingURL=emergencyRepayforLoopingPools.js.map